const ACTIONS = {
  LOAD_SET_START: 'LOAD_SET_START',
  LOAD_SET_COMPLETE: 'LOAD_SET_COMPLETE',
  LOAD_SET_ERROR: 'LOAD_SET_ERROR',
  LOAD_ALL_SET_START: 'LOAD_ALL_SET_START',
  LOAD_ALL_SET_COMPLETE: 'LOAD_ALL_SET_COMPLETE',
  LOAD_ALL_SET_ERROR: 'LOAD_ALL_SET_ERROR',
  LOAD_TAG_START: 'LOAD_TAG_START',
  LOAD_TAG_COMPLETE: 'LOAD_TAG_COMPLETE',
  LOAD_TAG_ERROR: 'LOAD_TAG_ERROR',
};

const filtersReducer = (state, action) => {
  const { payload } = action;

  switch (action.type) {
    // load versionSets action
    case ACTIONS.LOAD_SET_START:
      return {
        ...state,
        versionSetsLoading: true,
        versionSetsError: false,
      };
    case ACTIONS.LOAD_SET_COMPLETE:
      return {
        ...state,
        versionSetsLoading: false,
        versionSets: [...state.versionSets, ...payload.versionSets],
        offset: payload.offset,
      };
    case ACTIONS.LOAD_SET_ERROR:
      return {
        ...state,
        versionSetsLoading: false,
        versionSetsError: true,
        offset: payload.offset,
      };
    // load all versionSets action
    case ACTIONS.LOAD_ALL_SET_START:
      return {
        ...state,
        allVersionSetsLoading: true,
        allVersionSetsError: false,
      };
    case ACTIONS.LOAD_ALL_SET_COMPLETE:
      return {
        ...state,
        allVersionSetsLoading: false,
        allVersionSets: payload.allVersionSets,
      };
    case ACTIONS.LOAD_ALL_SET_ERROR:
      return {
        ...state,
        allVersionSetsLoading: false,
        allVersionSetsError: true,
      };
    // load tags action
    case ACTIONS.LOAD_TAG_START:
      return {
        ...state,
        tagsLoading: true,
        tagsError: false,
      };
    case ACTIONS.LOAD_TAG_COMPLETE:
      return {
        ...state,
        tagsLoading: false,
        tags: payload.tags,
      };
    case ACTIONS.LOAD_TAG_ERROR:
      return {
        ...state,
        tagsLoading: false,
        tagsError: true,
      };
    default:
      throw new Error();
  }
};

export { ACTIONS, filtersReducer };
